import { UserMenu } from "@/features/Auth/components/UserMenu/UserMenu";
import { IconButton, Menu, MenuButton, Spacer, Stack } from "@chakra-ui/react";
import { Icon, Page, PageContent, PageContentHeader, ScrollableContent } from "@pufflig/prompt-studio-ui";

export const HomepageSkeleton = () => {
  return (
    <Page>
      <PageContent>
        <PageContentHeader>
          <Spacer />
          <Stack gap="spacing-xs" direction="row">
            <Menu>
              <MenuButton
                variant="ghost"
                as={IconButton}
                paddingLeft="spacing-xs"
                paddingRight="spacing-xs"
                icon={<Icon name="more-info" size="md" />}
              />
            </Menu>
            <UserMenu />
          </Stack>
        </PageContentHeader>
        <ScrollableContent></ScrollableContent>
      </PageContent>
    </Page>
  );
};
